export default "__VITE_ASSET__nmeE7PyE__"